import React from 'react';
import './LoanCard.css';

function LoanCard({ title, image, onClick }) {
  return (
    <div
      className="loan-card"
      onClick={onClick}
      style={{ cursor: 'pointer' }} // makes it clear it's clickable
    >
      <h3 className="loan-title">{title}</h3>
      <div className="loan-bottom">
        <img src={image} alt={title} className="loan-image" />
        <div className="loan-arrow">
          <span>&#8599;</span>
        </div>
      </div>
    </div>
  );
}

export default LoanCard;
